<!-- Accordion of Main Sections -->
<div class="d-block mb-3 text-end">
  <button
    class="btn btn-primary-dark btn-sm rounded text-xxs shadow mt-3"
    data-bs-toggle="modal"
    data-bs-target="#create_main_section_modal"
    @click="open_create_main_section_modal"
  >
    Create Main Section
  </button>

  <!-- Show ONLY when there are main sections -->
  <button
    v-if="main_sections && main_sections.length"
    class="btn btn-primary-dark btn-sm rounded text-xxs shadow mt-3 ms-2"
    data-bs-toggle="modal"
    data-bs-target="#reorder_main_sections_modal"
    @click="open_reorder_main_sections_modal"
  >
    Reorder Main Sections
  </button>
</div>

<div class="card-body">
  <!-- Render the accordion ONLY when there are items -->
  <div
    v-if="main_sections && main_sections.length"
    class="accordion rounded-lg"
    id="main_sections_accordion"
  >
    <div
      class="accordion-item p-1 border"
      v-for="(main, idx) in main_sections"
      :key="'main-' + main.id"
    >
      <h2 class="accordion-header p-0">
        <div class="d-flex align-items-center w-100 border-0 rounded-lg text-xxs">
          <!-- Order Number Badge -->
          <div
            class="fw-bold text-xs text-dark d-flex align-items-center justify-content-center p-0"

          >
            <span v-if="main.order_number !== undefined && main.order_number !== null">
              {{ main.order_number }}.
            </span>
            <span v-else>
              {{ idx + 1 }}.
            </span>
          </div>

          <div class="flex-grow-1">
            <input
              type="text"
              class="form-control form-control-sm ps-2 text-xs bg-white border-0 fw-bold"
              :value="main.order_number ? `${main.order_number}. ${main.name}` : main.name"
              readonly
            />
          </div>

          <button
            class="border-0 mb-1 ms-2 ml d-flex align-items-center justify-content-center rounded-lg"
            type="button"
            title="Edit main section"
            aria-label="Edit main section"
            data-bs-toggle="modal"
            data-bs-target="#edit_main_section_modal"
            @click.stop="open_edit_main_section_modal(main)"
          >
            <i class="bi bi-pencil-fill text-x"></i>
          </button>

          <button
            class="border-0 mb-1 ms-2 ml d-flex align-items-center justify-content-center rounded-lg me-1"
            type="button"
            title="Delete main section"
            aria-label="Delete main section"
            @click.stop="delete_main_section(main.main_section_id)"
          >
            <i class="bi bi-trash-fill text-x"></i>
          </button>

          <!-- Add Sub-section -->
          <button
            class="btn btn-primary-dark btn-sm text-xxs mb-1 shadow-sm"
            data-bs-toggle="modal"
            data-bs-target="#create_sub_section_modal"
            @click="open_create_sub_section_modal(main)"
          >
            Add Sub-section
          </button>

          <!-- Expand / collapse chevron -->
          <a
            class="fw-bold fs-6 p-0 ms-2 text-dark"
            @click.stop="toggle_main(idx)"
            type="button"
          >
            <i class="bi" :class="{'bi-chevron-down': !main.expanded, 'bi-chevron-up': main.expanded}"></i>
          </a>
        </div>
      </h2>

      <!-- Collapsible body -->
      <div class="collapse ms-2 shadow" :class="{ show: main.expanded }">
        <div class="accordion-body border table-border-color">
          <div class="d-flex align-items-center gap-1 mb-2">
            <p class="text-dark text-xs mb-0">Sub-Sections :</p>

            <button
              v-if="main.sub_sections && main.sub_sections.length > 0"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm"
              data-bs-toggle="modal"
              data-bs-target="#reorder_sections_modal"
              @click="open_reorder_modal(main)"
            >
              <i class="bi bi-arrow-down-up text-primary-blue"></i>
              Reorder
            </button>
          </div>

          <div class="mb-3">
            <template v-if="main.sub_sections && main.sub_sections.length">
              <div
                class="d-flex align-items-center mb-2 border-bottom border-2 p-2"
                v-for="(section, sidx) in main.sub_sections"
                :key="'sub-' + section.id"
              >
                <!-- Sub-section Order Number -->
                <div
                  class="text-dark text-xs fw-bold d-flex align-items-center justify-content-center me-1"
                >
                  <span v-if="section.order !== undefined && section.order !== null">
                    {{ section.order }}.
                  </span>
                  <span v-else>
                    {{ sidx + 1 }}.
                  </span>
                </div>

                <!-- Sub-section name -->
                <input
                  type="text"
                  class="form-control form-control-sm text-xs ps-2 pe-2 border-0 flex-grow-1 me-2 bg-white"
                  :value="section.name"
                  readonly
                />

                <!-- Actions (side-by-side) -->
                <div class="d-flex align-items-center me-2">


                  <!-- Edit -->
                  <button
                    class="border-0 d-flex align-items-center justify-content-center rounded-lg me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_sub_section_modal"
                    @click="open_edit_sub_section_modal(section)"
                    title="Edit sub section"
                    aria-label="Edit sub section"
                  >
                    <i class="bi bi-pencil-fill text-x"></i>
                  </button>

                  <!-- Delete -->
                  <button
                    class="border-0 d-flex align-items-center justify-content-center rounded-lg me-1"
                    type="button"
                    title="Delete sub section"
                    aria-label="Delete sub section"
                    @click.stop="delete_sub_section(section.id, main.id)"
                  >
                    <i class="bi bi-trash-fill text-x"></i>
                  </button>

                  <!-- Assign Questions -->
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                    data-bs-toggle="modal"
                    data-bs-target="#assign_questions_modal"
                    @click="open_assign_modal(section.id)"
                    title="Assign questions"
                    aria-label="Assign questions"
                  >
                    Assign
                  </button>
                </div>
              </div>
            </template>

            <div v-else class="text-muted text-xxs">
              No sub-sections added yet
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state (only shows when there are NO main sections) -->
  <div v-else class="text-center py-4 text-muted text-xxs bg-white">
    No main sections found.
  </div>
</div>


<teleport to="body">
<div class="modal fade" id="create_main_section_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Create Main Section</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Main Section Name:</label>
          <input
            type="text"
            v-model.trim="new_main_section.name"
            class="modal-form-control form-control text-xxs"
            placeholder="Enter main section name"
          />
          <small v-if="main_section_name_error" class="text-danger p-2 text-xxs fw-bold">
            Please enter a main section name
          </small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description (optional):</label>
          <textarea
            v-model.trim="new_main_section.description"
            class="modal-form-control form-control text-xxs"
            placeholder="Enter description"
          ></textarea>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Order Number:</label>
          <input
            type="number"
            min="1"
            step="1"
            v-model.number="new_main_section.order_number"
            class="modal-form-control form-control text-xxs"
            placeholder="e.g. 1"
            inputmode="numeric"
          />
          <small v-if="order_number_error" class="text-danger p-2 text-xxs fw-bold">
            Order number must be a positive whole number
          </small>
        </div>

      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="create_main_section"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="edit_main_section_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Main Section</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                @click="show_edit_main_section_modal = false"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Main Section Name:</label>
          <input
            type="text"
            v-model.trim="current_edit_main_section.name"
            :class="{'is-invalid': main_section_name_error}"
            @input="main_section_name_error = false"
            class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
            placeholder="Main section name"
            @keyup.enter="save_edited_main_section"
          />
          <div v-if="main_section_name_error" class="invalid-feedback small">
            Please enter a main section name
          </div>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description (optional):</label>
          <textarea
            v-model.trim="current_edit_main_section.description"
            class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
            placeholder="Description"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="save_edited_main_section"
          :disabled="!current_edit_main_section.name?.trim()"
          data-bs-dismiss="modal"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Create Sub-section Modal -->
 <teleport to="body">
<div class="modal fade" id="create_sub_section_modal" tabindex="-1" aria-labelledby="create_sub_section_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_sub_section_label">
          Add Sub-section to {{ current_main_section?.name || '' }}
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Sub-section Name:</label>
          <input
            type="text"
            v-model.trim="new_section_name"
            class="modal-form-control form-control text-xxs"
            placeholder="Enter sub-section name"
          />
          <small v-if="section_name_error" class="text-danger p-2 text-xxs fw-bold">
            Please enter a sub-section name
          </small>
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="create_sub_section"
          data-bs-dismiss="modal"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Edit Sub-section Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_sub_section_modal" tabindex="-1" aria-labelledby="edit_sub_section_label">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Sub-section</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"
                @click="show_edit_section_modal = false"></button>
      </div>

      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Sub-section Name:</label>
          <input
            type="text"
            v-model.trim="current_edit_section.name"
            :class="{'is-invalid': section_name_error}"
            @input="section_name_error = false"
            class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
            placeholder="Sub-section Name"
            @keyup.enter="save_edited_section"
          />
          <div v-if="section_name_error" class="invalid-feedback small">
            Please enter a sub-section name
          </div>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Order (optional):</label>
          <input
            type="number"
            v-model.number="current_edit_section.order"
            class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
            placeholder="Order"
            min="1"
            @keyup.enter="save_edited_section"
          />
        </div>

        <div v-if="general_error" class="alert alert-danger small mt-2 p-2">
          {{ general_error }}
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="save_edited_section"
          :disabled="!current_edit_section.name?.trim()"
          data-bs-dismiss="modal"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Questions Modal -->
<teleport to="body">
  <div
    class="modal fade"
    id="assign_questions_modal"
    tabindex="-1"
    aria-labelledby="assign_questions_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <!-- Header -->
        <div class="modal-header border-bottom-0 cute-header">
          <p class="modal-title text-white text-xxs" id="assign_questions_modal_label">
            Assign Questions
          </p>
          <button
            type="button"
            class="modal-btn-close btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <!-- Body -->
        <div class="modal-body py-3">
          <div class="card mb-4 border-0">
            <div class="card-body p-0">
              <!-- Loader -->
              <div v-if="is_loading_questions" class="text-center py-4">
                <div class="spinner-border" role="status"></div>
                <p class="text-muted mt-2 fs-6">Loading questions...</p>
              </div>
              <div v-else>
                <!-- Search -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <p class="text-muted mb-0 text-xs">
                    Toggle to assign or unassign <strong>main questions</strong>.
                    Dependent questions are assigned automatically.
                  </p>
                  <div class="input-group  w-auto text-xxs">
                    <input
                      type="text"
                      class="form-control form-control-sm text-xxs rounded-lg"
                      placeholder="Search questions..."
                      v-model="question_search"
                    />
                  </div>
                </div>
                <!-- Table -->
                <div class="table-responsive">
                  <table class="table table-bordered table-hover align-middle">
                    <thead class="table-header text-white">
                      <tr class="text-xs">
                        <th class="text-center">Question</th>
                        <th class="text-center">Type</th>
                        <th class="text-center">Number</th>
                        <th class="text-center">Assign</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- MAIN QUESTIONS -->
                      <template v-for="q in filtered_questions" :key="q.id">
                        <tr class="text-xxs">
                          <!-- Question column -->
                          <td>
                            <div class="d-flex align-items-start gap-2">
                              <span class="status-badge bg-primary text-xxs rounded-lg">
                                Main
                              </span>
                              <div>
                                <div class="fw-medium">
                                  {{ q.question_text || 'No question text' }}
                                </div>
                              </div>
                            </div>
                          </td>
                          <!-- Type -->
                          <td>
                            {{ format_question_type(q.question_type?.question_type || q.question_type) }}
                          </td>
                          <!-- Number -->
                          <td>{{ q.question_number || '-' }}</td>
                          <!-- Assign -->
                          <td class="text-center">
                            <div class="form-check form-switch d-flex justify-content-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :checked="q.is_assigned"
                                :disabled="q.is_loading"
                                @change="on_toggle_assign(q)"
                              />
                            </div>
                          </td>
                        </tr>

                        <!-- DEPENDENT QUESTIONS -->
                        <tr
                          v-for="dq in q.dependent_questions"
                          :key="'dep-' + dq.id"
                          class="bg-light text-xxs"
                        >
                          <td class="ps-2">
                            <div class="d-flex align-items-start gap-2">
                              <span class="status-badge bg-warning text-dark text-xxs rounded-lg">
                                Dependent
                              </span>

                              <div>
                                <div class="fw-medium">
                                  {{ dq.question_text }}
                                </div>
                              </div>
                            </div>
                          </td>

                          <td>
                            {{ format_question_type(dq.question_type) }}
                          </td>
                          <td>{{ dq.question_number || '-' }}</td>
                          <td>
                            <span class="text-center status-badge bg-info rounded-lg text-xxs">
                              Auto-assigned
                            </span>
                          </td>


                        </tr>
                      </template>

                      <!-- Empty state -->
                      <tr v-if="filtered_questions.length === 0">
                        <td colspan="5" class="text-center py-3 text-muted fs-6">
                          No matching questions found
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                  <p class="text-muted text-xs">
                    Showing {{ filtered_questions.length }} of {{ question_list.length }} main questions
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</teleport>

<!-- Reorder Sections Modal -->
<teleport to="body">
<div class="modal fade" id="reorder_sections_modal" tabindex="-1" aria-labelledby="reorder_sections_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Reorder Sections</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body overflow-auto">
        <div class="reorder-instructions text-muted text-xxs mb-3 p-2 bg-info-subtle border-start border-3 rounded">
          <i class="fas fa-info-circle"></i> Drag sub sections up or down to reorder them
        </div>

        <div class="sortable-list" id="sortable-sections-list">
          <div v-for="(section, index) in current_reorder_sections" :key="section.id"
            class="sortable-item mb-2 p-2 border rounded bg-light position-relative cursor-move transition"
            draggable="true"
              @dragstart="drag_start_section($event, index)"
              @dragover.prevent="drag_over($event)"
              @drop.prevent="drag_drop_section($event, index)"
              @dragend="drag_end($event)"
          >
            <div class="d-flex align-items-center">
              <div class="drag-handle me-3 text-muted"><i class="fas fa-grip-vertical fs-5"></i></div>
              <div class="question-number card-header-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 text-center text-nowrap text-xs">
                {{ index + 1 }}
              </div>
              <div class="flex-grow-1">
                <div class="section-title fw-bold text-xs text-dark">{{ section.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"  @click="update_section_order">
          Update Order
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Reorder Sections Modal -->
 <teleport to="body">
<div class="modal fade" id="reorder_main_sections_modal" tabindex="-1" aria-labelledby="reorder_main_sections_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Reorder Main Sections</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body overflow-auto">
        <div class="reorder-instructions text-muted text-xxs mb-3 p-2 bg-info-subtle border-start border-3 rounded">
          <i class="fas fa-info-circle"></i> Drag main sections up or down to reorder them
        </div>

        <div class="sortable-list" id="sortable-sections-list">
          <div v-for="(section, index) in current_reorder_sections" :key="section.id"
            class="sortable-item mb-2 p-2 border rounded bg-light position-relative cursor-move transition"
            draggable="true"
              @dragstart="drag_start_section($event, index)"
              @dragover.prevent="drag_over($event)"
              @drop.prevent="drag_drop_section($event, index)"
              @dragend="drag_end($event)"
          >
            <div class="d-flex align-items-center">
              <div class="drag-handle me-3 text-muted"><i class="fas fa-grip-vertical fs-5"></i></div>
              <div class="question-number card-header-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 text-center text-nowrap text-xs">
                {{ index + 1 }}
              </div>
              <div class="flex-grow-1">
                <div class="section-title fw-bold text-xs text-dark">{{ section.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"  @click="update_main_section_order">
          Update Order
        </button>
      </div>
    </div>
  </div>
</div>
</teleport> 